import { render, staticRenderFns } from "./EditorNumber.vue?vue&type=template&id=183f924e&scoped=true&"
import script from "./EditorNumber.vue?vue&type=script&lang=js&"
export * from "./EditorNumber.vue?vue&type=script&lang=js&"
import style0 from "./EditorNumber.vue?vue&type=style&index=0&id=183f924e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f924e",
  null
  
)

export default component.exports